<template>
  <section class="PaymentCancellationModal">
    <section class="flex justify-content space-between mt-5 pt-5">
      <h3 class="form-wrapper-body-title ">Cancel Registration </h3>
      <p class="PaymentCancellationModal__warning">
        Are you sure you want to cancel your registration? 
        <span v-if="isWaitlistCancellation">By clicking cancel,<span style='font-weight: 600'>your spot in the waitlist will be lost.</span></span>
        <span v-else>By clicking cancel, <span style='font-weight: 600'>your spot in the acticity will be lost.</span></span>

      </p>
    </section>

    <footer class="form-wrapper-footer ">

        <button
          @click="cancle"
          :class="['form-wrapper-footer-button', 'danger-btn']"
          :style="{ width: '40%', marginRight: '1rem'}"
        >
          Cancel
        </button>
    

        <button
          @click="back"
          :class="[
            'form-wrapper-footer-button',
            'primary-btn',
            false && 'ie-spinner',
          ]"
          :style="{ width: '40%' }"
        >
          Back
        </button>
   
    
    </footer>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PaymentCancellationModal",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      "options",
    ]),
    isWaitlistCancellation() {
      return this.options.isWaitlistCancellation;
    },
  },
  methods: {
    ...mapActions([
      "openModal",
      "closeModal",
      "toggleFade",
      "cancelPaymentFlow",
      "cancelWaitlistPaymentFlow",
    ]),
    async cancle() {
      const { school: schoolSlug } = this.$router.currentRoute.params;

      try {
        if (this.options.isWaitlistCancellation) {
        await this.cancelWaitlistPaymentFlow(this.options.rosterDay);
      } else {
        await this.cancelPaymentFlow(schoolSlug);
      }
      } catch (error) {
      } finally {
        this.closeModal({
        dangerClose: true,
      });
        this.toggleFade(false);
      }
    },
    back() {
      this.openModal({
        modal: this.options.backToModal,
        options: {...this.options.backToModalOptions},
      });
      this.toggleFade(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";

.PaymentCancellationModal {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .button-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content:center;
    align-items: center;

  }
  &::-webkit-scrollbar {
    width: 8px;
    cursor: pointer;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: $GreySecondary;
    cursor: pointer;
  }
  &__warning {
    text-align: center;
    padding: 0 2rem;
    font-size: 1.2rem;
    font-weight: 500;
    margin-top: 3rem;
  }
  h3 {
  margin-top: 2rem;
  font-size: 1.6rem;
  font-weight: 500;
}
}

</style>



// WEBPACK FOOTER //
// src/components/modals/PaymentCancellationModal.vue